import React, { useState } from 'react';
import FormField from '../../FormField';
import { Colors, RadioGroup, Text, TextButton } from 'library';
import { Collapse, Grid, TextField } from '@mui/material';
import { FormFieldProps } from '../../FormTypes';

const breakOptions = {
    false: 'Allow workers to clock the exact break times they took',
    true: 'Automatically add a __ minute break if the worker worked over __ hours',
};

export default function BreakRequiredField({
    breakLength,
    addMinimumBreak,
    breakEveryNHours,
}: {
    breakLength: FormFieldProps<number | undefined>;
    addMinimumBreak: FormFieldProps<boolean>;
    breakEveryNHours: FormFieldProps<number | null>;
}) {
    const [expandBreakHelp, setExpandBreakHelp] = useState(false);

    function onRadioGroupChange(val: string) {
        addMinimumBreak.setValue(val === 'true');
        if (val !== 'true') {
            breakEveryNHours.setValue(null);
        }
    }

    return (
        <FormField title="4. Does this job require a break?" style={{ marginTop: 20 }}>
            <Grid container direction="column" gap={2} marginTop={2}>
                <Grid item>
                    <RadioGroup
                        style={{ padding: '0 5px' }}
                        value={addMinimumBreak.value.toString()}
                        setValue={onRadioGroupChange}
                        values={breakOptions}
                    />
                    {addMinimumBreak.value && (
                        <>
                            <Grid container item direction="row" alignItems="center" paddingLeft={5}>
                                <Text variant="caption" bold>
                                    Break required of{' '}
                                </Text>
                                <TextField
                                    disabled={!addMinimumBreak.value}
                                    value={breakLength.value}
                                    onChange={(e) => breakLength.setValue(parseInt(e.target.value))}
                                    id="job-form-break-length-input"
                                    variant="standard"
                                    type="number"
                                    sx={styles.inputStyles}
                                    InputProps={{
                                        inputProps: {
                                            min: 1,
                                        },
                                    }}
                                />
                                <Text variant="caption" bold>
                                    minutes if the worker worked over{' '}
                                </Text>
                                <TextField
                                    disabled={!addMinimumBreak.value}
                                    value={breakEveryNHours.value}
                                    onChange={(e) => breakEveryNHours.setValue(parseInt(e.target.value))}
                                    id="job-form-break-hours"
                                    variant="standard"
                                    type="number"
                                    sx={styles.inputStyles}
                                    InputProps={{
                                        inputProps: {
                                            min: 1,
                                        },
                                    }}
                                />
                                <Text variant="caption" bold>
                                    hours
                                </Text>
                                <TextButton
                                    onClick={() => setExpandBreakHelp(!expandBreakHelp)}
                                    buttonStyle={{ width: undefined, marginLeft: 5 }}
                                    textStyle={{ fontSize: 12 }}
                                >
                                    How does this work?
                                </TextButton>
                                <Collapse in={expandBreakHelp}>
                                    <Text variant="body2" textStyle={{ marginTop: 5 }}>
                                        Ex: For a 60 minute break for 8 hours, if a worker clocks from 8AM-5PM with a 30
                                        minute break the break will be extended to 60 minutes. If they clocked from 8:00
                                        AM-4:45 PM with a 30 minute break the break will be extended to 45 minutes.
                                    </Text>
                                </Collapse>
                            </Grid>
                        </>
                    )}
                </Grid>
            </Grid>
        </FormField>
    );
}

const styles = {
    inputStyles: {
        margin: '0 5px',
        fontFamily: 'WorkSans-Regular',
        width: 50,
        color: Colors.darkNavy,
        borderColor: Colors.darkNavy,
        '& .Mui-focused': {
            color: Colors.darkNavy,
        },
    },
};
